// define config for client here
export default {
  clientNameUseForApiRequest: "resolu",
  clientTagId: 10230
};
